/**
 * DoorTile - Locked door that requires matching key (parameterized by color)
 * Single class handles all 4 door colors
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export type DoorColor = "green" | "red" | "orange" | "blue";

export class DoorTile extends BaseTile {
  private color: DoorColor;

  constructor({
    col,
    row,
    color,
    id,
  }: {
    col: number;
    row: number;
    color: DoorColor;
    id?: string;
  }) {
    super(id ?? `door-${color}-${col}-${row}`, col, row);
    this.color = color;
  }

  tileType(): TileIndex {
    switch (this.color) {
      case "green":
        return TILE.DOOR_GREEN;
      case "red":
        return TILE.DOOR_RED;
      case "orange":
        return TILE.DOOR_ORANGE;
      case "blue":
        return TILE.DOOR_BLUE;
    }
  }

  textureDescriptor(): TextureDescriptor {
    // Orange door is stored as yellow-door.png in the assets
    const fileName = this.color === "orange" ? "yellow" : this.color;
    return {
      type: "png",
      path: `tiles/${fileName}-door.png`,
    };
  }

  getColor(): DoorColor {
    return this.color;
  }

  clone(): DoorTile {
    const copy = new DoorTile({
      col: this.col,
      row: this.row,
      color: this.color,
      id: this.id,
    });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return {
      type: "door",
      color: this.color,
      id: this.id,
      col: this.col,
      row: this.row,
    };
  }
}
